import { render, staticRenderFns } from "./UretimReceteCikti.vue?vue&type=template&id=ced974f8"
import script from "./UretimReceteCikti.vue?vue&type=script&lang=js"
export * from "./UretimReceteCikti.vue?vue&type=script&lang=js"
import style0 from "./UretimReceteCikti.vue?vue&type=style&index=0&id=ced974f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports